import { combineReducers } from '@reduxjs/toolkit'
import { appReducer } from 'apps/formsCreationKit/store/reducers/entities/app'
import { conditionsReducer } from 'apps/formsCreationKit/store/reducers/entities/conditions'
import { dataSourceContextParamsReducer } from 'apps/formsCreationKit/store/reducers/entities/dataSourceContextParams'
import { entriesReducer } from 'apps/studio/store/reducers/entities/entries'
import { sheetsReducer } from 'apps/studio/store/reducers/entities/sheets'
import { sectionsReducer } from 'apps/studio/store/reducers/entities/sections'
import { elementsReducer } from 'apps/studio/store/reducers/entities/elements'
import { pagesReducer } from 'apps/studio/store/reducers/entities/pages'
import { pdfReducer } from 'apps/studio/store/reducers/entities/pdf'
import { operationsReducer } from 'apps/studio/store/reducers/entities/operations'
import { pdfPageMetaReducer } from 'apps/studio/store/reducers/pdfPageMeta'
import { layoutsReducer } from 'apps/studio/store/reducers/entities/layouts'

export const entitiesReducers = combineReducers({
  conditions: conditionsReducer,
  operations: operationsReducer,
  dataSourceContextParams: dataSourceContextParamsReducer,
  entries: entriesReducer,
  sheets: sheetsReducer,
  sections: sectionsReducer,
  app: appReducer,
  elements: elementsReducer,
  pages: pagesReducer,
  pdf: pdfReducer,
  pdfPageMeta: pdfPageMetaReducer,
  layouts: layoutsReducer,
})
